import { useState } from 'react'
import { Download, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAppDispatch } from '@/redux/hooks'
import { exportCharter } from '../../redux/asyncThunks/charterThunks'
import { toast } from 'sonner'

interface CharterExportButtonProps {
  roomId: string
  teamId: number
  version?: number
  isDraft?: boolean
  disabled?: boolean
  variant?: 'default' | 'outline' | 'ghost'
  size?: 'default' | 'sm' | 'lg'
}

export function CharterExportButton({
  roomId,
  teamId,
  version,
  isDraft = false,
  disabled = false,
  variant = 'outline',
  size = 'sm',
}: CharterExportButtonProps) {
  const dispatch = useAppDispatch()
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async () => {
    setIsExporting(true)
    try {
      await dispatch(exportCharter({ roomId, teamId, version, isDraft }))
      toast.success('Charter downloaded!')
    } catch {
      toast.error('Failed to download charter. Please try again.')
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleExport}
      disabled={disabled || isExporting}
      className='gap-1.5'
    >
      {isExporting ? (
        <Loader2 className='h-4 w-4 animate-spin' />
      ) : (
        <Download className='h-4 w-4' />
      )}
      {isDraft ? 'Export Draft' : 'Export Charter'}
    </Button>
  )
}
